// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_splidejs_splide_dist_css_splide_min_css-node_modules_screen-size-detecto-e49494"], function() { return __webpack_require__("./src/js/main.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
